const formatOptions: Intl.NumberFormatOptions = { style: 'currency', currency: 'USD', maximumFractionDigits: 0 };
export const priceFormat = new Intl.NumberFormat('en-US', formatOptions);